/* Theme entry point.

   Ported from the redesign prototype's app.js. Same modules, same order;
   the cart module is the Shopify one, and the filter bar is Shopify's, so
   neither the prototype's cart-store nor its filters.js comes across.

   Loaded as a module from layout/theme.liquid. All assets sit in the same
   CDN folder, so the relative imports below resolve. */

import { initPressFeedback, initScrollEdge, initSheet, initCarousel } from './motion.js';
import { initWordmark } from './wordmark.js';
import { initAccordions } from './accordion.js';
import { initCart } from './cart.js';
import { initConsent } from './consent.js';
import { initNewsletterPopup } from './newsletter-popup.js';
import { initSubscribe } from './subscribe.js';
import { initSearch } from './search.js';

initPressFeedback(document);
initScrollEdge(document.querySelector('[data-header]'));
initWordmark(document);
initAccordions(document);
initCart(document);
initConsent(document);
initNewsletterPopup(document);
initSubscribe(document);
initSearch(document);

initSheet({
  sheet: document.querySelector('[data-menu-sheet]'),
  scrim: document.querySelector('[data-menu-scrim]'),
  openers: [...document.querySelectorAll('[data-open-menu]')],
  closers: [...document.querySelectorAll('[data-close-menu]')],
});

initCarousel(document.querySelector('[data-carousel]'));

/* Only one filter popover open at a time, closing on outside pointerdown
   rather than click so it matches the press-down feel of everything else. */
const dds = [...document.querySelectorAll('.dd')];
dds.forEach((dd) =>
  dd.addEventListener('toggle', () => {
    if (dd.open) dds.forEach((other) => other !== dd && (other.open = false));
  })
);
document.addEventListener('pointerdown', (e) => {
  dds.forEach((dd) => {
    if (dd.open && !dd.contains(e.target)) dd.open = false;
  });
});

/* Storefront filters apply on change — no "Приложи" button for anyone with
   JS. The <noscript> submit stays in the markup for anyone without. */
const filterForm = document.querySelector('[data-filter-form]');
if (filterForm) {
  filterForm.addEventListener('change', () => filterForm.submit());
}

/* The product page's back button links to a collection, which is the right
   answer for a customer who arrived from outside the store. A customer who
   came from a listing on this store wants the listing they left — the same
   garment chip, the same filters, the same place on the page — and only a
   history step returns that. The link stays the fallback: no history, or a
   referrer from elsewhere, and the href is used as written. */
const backBtn = document.querySelector('[data-back]');
if (backBtn && history.length > 1 && document.referrer) {
  let sameSite = false;
  try {
    sameSite = new URL(document.referrer).origin === location.origin;
  } catch {
    sameSite = false;
  }
  if (sameSite) {
    backBtn.addEventListener('click', (event) => {
      /* A modified click is the customer asking for a new tab. Let it go. */
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      history.back();
    });
  }
}

/* Related products come from the recommendations API, which only answers
   after the page has rendered. */
const related = document.querySelector('[data-related]');
if (related && related.dataset.url) {
  fetch(related.dataset.url)
    .then((response) => response.text())
    .then((html) => {
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.section');
      if (!section) return;
      related.replaceWith(section);
      initPressFeedback(section);
    })
    .catch(() => related.remove());
}
